import React from 'react';
import { colors } from 'styleguide';

interface Props {
  size?: number;
  color?: string;
}

const TextCenter = ({ size = 16, color = colors('neutral', 3) }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="3" y1="3" x2="17" y2="3" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <line x1="4" y1="15" x2="15" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <line x1="6" y1="9" x2="13" y2="9" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default TextCenter;
